import React, {PureComponent} from "react"

import {Price} from "@irati/payments/types"
import {formatCurrency} from "@irati/utils/currency/formatCurrency"

export interface RewardDescriptionProps {
  text: string
  costPerUnit?: Price
}

class DisplayDescription extends PureComponent<RewardDescriptionProps> {
  render() {
    const {costPerUnit, text} = this.props
    if (costPerUnit) {
      return (
        <span>
          {formatCurrency({currencyCode: costPerUnit.currency, value: costPerUnit.amount, isCents: false})} {text}
        </span>
      )
    }
    return <span>{text}</span>
  }
}

export default DisplayDescription
